import { render } from "./SurveyQ52.vue?vue&type=template&id=7aa60d8e&ts=true"
import script from "./SurveyQ52.vue?vue&type=script&lang=ts"
export * from "./SurveyQ52.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__